/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formcompanyname_Placeholder2Inputs */

const ja_contact_formcompanyname_placeholder2 = /** @type {(inputs: Contact_Formcompanyname_Placeholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会社名`)
};

const en_contact_formcompanyname_placeholder2 = /** @type {(inputs: Contact_Formcompanyname_Placeholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eg. Acme Inc.`)
};

/**
* | output |
* | --- |
* | "eg. Acme Inc." |
*
* @param {Contact_Formcompanyname_Placeholder2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formcompanyname_placeholder2 = /** @type {((inputs?: Contact_Formcompanyname_Placeholder2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formcompanyname_Placeholder2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formcompanyname_placeholder2(inputs)
	return en_contact_formcompanyname_placeholder2(inputs)
});
export { contact_formcompanyname_placeholder2 as "contact_formCompanyName_placeholder" }